import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useEstatisticasProducao } from "../context/EstatisticasProducaoContext";
import { producaoService } from "../../../../services/producaoService";

const EstatisticasBordas: React.FC = () => {
  const { appliedFilters } = useEstatisticasProducao();

  const { data: bordas = [], isLoading } = useQuery({
    queryKey: ["bordas", appliedFilters],
    queryFn: () =>
      producaoService.getBordas({
        dataInicio: appliedFilters.dataInicio,
        dataFim: appliedFilters.dataFim,
        lojaId: appliedFilters.lojaId,
      }),
    enabled: !!(appliedFilters.dataInicio && appliedFilters.dataFim),
  });

  if (isLoading) {
    return (
      <div className="mt-6 rounded-lg bg-white shadow">
        <div className="border-b border-neutral-200 px-6 py-4">
          <h3 className="text-lg font-medium text-neutral-900">
            Quantidade de borda produzida
          </h3>
        </div>
        <div className="p-6">
          <div className="py-8 text-center text-neutral-500">Carregando...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-6 rounded-lg bg-white shadow">
      <div className="border-b border-neutral-200 px-6 py-4">
        <h3 className="text-lg font-medium text-neutral-900">
          Quantidade de borda produzida
        </h3>
      </div>
      <div className="p-6">
        {bordas.length === 0 ? (
          <div className="py-8 text-center text-neutral-500">
            Nenhum dado encontrado para o período selecionado.
          </div>
        ) : (
          <div className="space-y-4">
            {bordas.map((item) => (
              <div
                key={
                  item.bordaId != null
                    ? `borda-${item.bordaId}`
                    : `borda-sem-id-${item.borda}`
                }
                className="rounded-lg border border-neutral-200 p-4 transition-shadow hover:shadow-md"
              >
                <div className="mb-3 flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <span className="text-2xl">🍕</span>
                    <h4 className="text-lg font-semibold text-neutral-800">
                      {item.borda}
                    </h4>
                  </div>
                  <div className="text-2xl font-bold text-primary">
                    {item.quantidadeTotal}
                  </div>
                </div>

                {item.tamanhos.length > 0 && (
                  <div className="ml-8 space-y-2">
                    {item.tamanhos.map((tamanho) => (
                      <div
                        key={tamanho.tamanho}
                        className="flex items-center justify-between text-sm"
                      >
                        <span className="text-neutral-600">
                          {tamanho.quantidade.toString().padStart(2, "0")} -{" "}
                          {tamanho.tamanho}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default EstatisticasBordas;
